<template>
  <div class="banner-container">
    <div class="common-banner" :class="clazz" v-for="(item, index) in bannerData"
         :style="{'backgroundImage': 'url(' + $global.globalPath + item.src + ')','text-align': item.position}">
      <div class="banner-content" :class="item.position === 'center' ? '' : 'left-banner'">
        <div class="misc">
          <h1 class="banner-title f48">{{item.title}}</h1>
          <h2 class="banner-subtitle f36" v-if="item.smalltitle">{{item.smalltitle.replace(/@/g, ' ')}}</h2>
          <div class="banner-divider dib" v-if="hasDivider"></div>
          <div>
            <p class="main-misc" v-html="item.content.replace(/@/g, '<br/>')"></p>
          </div>
        </div>
        <div class="buttons">
          <slot name="buttons"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'banner',
  data () {
    return {
      bannerData: []
    }
  },
  props: {
    url: {
      type: [String, Number],
      default: ''
    },
    clazz: {
      type: String,
      default: ''
    },
    hasDivider: {
      type: Boolean,
      default: false
    },
    isSolution: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getBanner (url) {
      if (this.isSolution) {
        this.$func.getSolutionBannerData(url, (r) => {
          this.bannerData = r
          if (this.bannerData.length > 1) {
            this.bannerData = this.bannerData.slice(0, 1)
          }
        })
      } else {
        this.$func.getBannerData(url, (r) => {
          this.bannerData = r
          if (this.bannerData.length > 1) {
            this.bannerData = this.bannerData.slice(0, 1)
          }
        })
      }
    }
  },
  created () {
    this.getBanner(this.url)
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/banner.scss";
</style>



// WEBPACK FOOTER //
// banner.vue?7c04da2f